// engine-wasm (= ADR-0027) の init + re-export wrapper。
// SOLO mode で engine を browser 内 (= server 不要) に駆動するための入口。
//
// web target の wasm は init() で .wasm を fetch して instantiate する。
// vite に bundle させるため `?url` import で asset URL を解決し init に渡す
// (= vite-plugin-wasm 不要の定番パターン)。

import init, { EngineHandle } from "duel-drive-sim-engine-wasm";
import wasmUrl from "duel-drive-sim-engine-wasm/duel_drive_sim_engine_wasm_bg.wasm?url";

let initPromise: Promise<unknown> | null = null;

// engine wasm を 1 度だけ初期化する (= 多重 init を防ぐ、 全 SOLO 入口から await する)。
export async function ensureEngineReady(): Promise<void> {
  initPromise ??= init({ module_or_path: wasmUrl });
  await initPromise;
}

export { EngineHandle };
